import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { usePermissionsAccess, useStableObject } from '../../../hooks'

const PermissionsContext = createContext()
export const usePermissionsContext = () => useContext(PermissionsContext)

export const QAPermissionsProvider = ({ children }) => {
  const { permissions, resolved: permissionsResolved } = usePermissionsAccess()
  const [overriddenPermissions, setOverriddenPermissions] = useState(permissions)
  const hasOverridden = useRef(false)

  // because the permissions are coming from a request, it is necessary to update after the first render because there is probably new data
  const stablePermissions = useStableObject(permissions)
  useEffect(() => {
    if (!hasOverridden.current) {
      setOverriddenPermissions(stablePermissions)
    }
  }, [stablePermissions])

  const updatePermission = useCallback((name, checked) => {
    hasOverridden.current = true
    setOverriddenPermissions((oldPermissions) => {
      return { ...oldPermissions, [name]: checked }
    })
  }, [])

  const resetPermissions = useCallback(() => {
    setOverriddenPermissions(stablePermissions)
  }, [stablePermissions])

  const value = useMemo(
    () => ({ permissions: overriddenPermissions, permissionsResolved, updatePermission, resetPermissions }),
    [overriddenPermissions, permissionsResolved, updatePermission, resetPermissions]
  )
  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>
}
